import { render } from "./meddraformslist.vue?vue&type=template&id=56f56492&scoped=true"
import script from "./meddraformslist.js?vue&type=script&lang=js"
export * from "./meddraformslist.js?vue&type=script&lang=js"

import "./meddraformslist.vue?vue&type=style&index=0&id=56f56492&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f56492"]])

export default __exports__